import React from "react";

// eslint-disable-next-line import/prefer-default-export
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ReferenceScreenImage() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "125",
    height: "100",
    fill: "none",
    viewBox: "0 0 125 100",
    children: [/*#__PURE__*/_jsx("path", {
      className: "illustrationStroke",
      fillRule: "evenodd",
      d: "M28 64.722l.001-4.222a1 1 0 012 0v6a1 1 0 01-2 0v-1.778zM29 56.5a1 1 0 01-1-1l.003-12.416V39a1 1 0 012 0v4.084L30 55.5a1 1 0 01-1 1z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      className: "illustrationStroke",
      fillRule: "evenodd",
      d: "M66 86h31a3 3 0 003-3V39a3 3 0 00-3-3H29a3 3 0 00-3 3v44a3 3 0 003 3h31v8.418l-8.96 1.194A1.2 1.2 0 0051.2 98h23.6a1.2 1.2 0 00.16-2.388L66 94.418V86zm2 6.667V88h29a5 5 0 005-5V39a5 5 0 00-5-5H29a5 5 0 00-5 5v44a5 5 0 005 5h29v4.667l-7.224.963A3.2 3.2 0 0051.2 100h23.602a3.2 3.2 0 00.423-6.37L68 92.667z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      className: "illustrationFill",
      d: "M101.584 85h21.679c9.909-46.7-24.21-85-60.722-85-35.386 0-73.683 36.45-59.52 85h21.395A4.983 4.983 0 0124 83V39a5 5 0 015-5h68a5 5 0 015 5v44c0 .711-.148 1.388-.416 2z"
    }), /*#__PURE__*/_jsx("path", {
      className: "illustrationFill",
      d: "M63.5 60.5l31.407-20.483c1.33-.868 3.092.086 3.092 1.675V82a2 2 0 01-2 2H35.49c-1.97 0-2.754-2.545-1.127-3.653L63.5 60.5z"
    }), /*#__PURE__*/_jsx("path", {
      className: "illustrationStroke",
      fillRule: "evenodd",
      d: "M80 66v-3a3 3 0 10-3 3h3zm-3-8a5 5 0 000 10h5v-5a5 5 0 00-5-5zM88 66h3a3 3 0 10-3-3v3zm8-3a5 5 0 00-10 0v5h5a5 5 0 005-5zM88 74v3a3 3 0 103-3h-3zm3 8a5 5 0 000-10h-5v5a5 5 0 005 5zM80 74h-3a3 3 0 103 3v-3zm-8 3a5 5 0 0010 0v-5h-5a5 5 0 00-5 5zM86 74h-4v-2h4v2zM86 68h-4v-2h4v2zM80 72v-4h2v4h-2zM86 72v-4h2v4h-2zM3.5 85a1 1 0 011-1h21a1 1 0 110 2h-21a1 1 0 01-1-1zm96 0a1 1 0 011-1H122a1 1 0 010 2h-21.5a1 1 0 01-1-1z",
      clipRule: "evenodd"
    })]
  });
}